import { useState } from 'react';
import { useOutsideClick } from 'hooks/useOutsideClick';
import { MainAdminLayout } from 'admin/layout/MainAdminLayout';
import { CreateQuestionModal } from 'admin/components/CreateQuestionModal';
import { QuestionTopBlock } from 'admin/components/Questions/QuestionTopBlock';
import { ModalContainer } from 'admin/containers/Questions/styled';
import { SampleDiv } from 'admin/components/CreateQuestionModal/styled';
import { MainTable } from 'admin/components/Table';
import { QuestionsHeader, QuestionData } from 'admin/TableDatas/mockDatas';
import { SHOW_CONTENT_NUMBERS, ACTIVE_TABS } from 'admin/utils/contants';

export const AdminQuestions = () => {
  const [selected, setSelected] = useState(SHOW_CONTENT_NUMBERS[0].value);
  const [questionsData, setQuestionsData] = useState(QuestionData);
  const { ref, isOpen, setIsOpen } = useOutsideClick();
  const [selectedItems, setSelectedItems] = useState(null);

  const showAnswerCreateModal = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <MainAdminLayout>
      {isOpen ? (
        <ModalContainer>
          <SampleDiv ref={ref}>
            <CreateQuestionModal
              questionsData={questionsData}
              setQuestionsData={setQuestionsData}
              showAnswerCreateModal={showAnswerCreateModal}
            />
          </SampleDiv>
        </ModalContainer>
      ) : null}

      <QuestionTopBlock
        showAnswerCreateModal={showAnswerCreateModal}
        setSelectedItems={setSelectedItems}
        selectedItems={selectedItems}
        selected={+selected}
        _data={questionsData}
        setData={setQuestionsData}
        setSelected={setSelected}
      />

      <MainTable
        selectedItems={selectedItems}
        setSelectedItems={setSelectedItems}
        headerData={QuestionsHeader}
        selected={+selected}
        setDelete={setQuestionsData}
        activeTab={ACTIVE_TABS.QUESTIONS}
        _data={questionsData}
      />
    </MainAdminLayout>
  );
};
